// frontend/src/data/ciudadesMexico.js

/**
 * Catálogo de ciudades principales de México por estado
 * Top 7 ciudades más pobladas/importantes por estado + opción "Otra ciudad"
 */

export const CIUDADES_POR_ESTADO = {
  "Aguascalientes": [
    "Aguascalientes",
    "Jesús María",
    "Calvillo",
    "Rincón de Romos",
    "Pabellón de Arteaga",
    "San Francisco de los Romo",
    "Asientos",
    "Otra ciudad..."
  ],
  
  "Baja California": [
    "Tijuana",
    "Mexicali",
    "Ensenada",
    "Rosarito",
    "Tecate",
    "San Felipe",
    "San Quintín",
    "Otra ciudad..."
  ],
  
  "Baja California Sur": [
    "La Paz",
    "Los Cabos",
    "San José del Cabo",
    "Cabo San Lucas",
    "Ciudad Constitución",
    "Loreto",
    "Guerrero Negro",
    "Otra ciudad..."
  ],
  
  "Campeche": [
    "Campeche",
    "Ciudad del Carmen",
    "Champotón",
    "Escárcega",
    "Calkiní",
    "Hopelchén",
    "Seybaplaya",
    "Otra ciudad..."
  ],
  
  "Chiapas": [
    "Tuxtla Gutiérrez",
    "Tapachula",
    "San Cristóbal de las Casas",
    "Comitán",
    "Palenque",
    "Tonalá",
    "Ocosingo",
    "Otra ciudad..."
  ],
  
  "Chihuahua": [
    "Chihuahua",
    "Juárez",
    "Cuauhtémoc",
    "Delicias",
    "Parral",
    "Nuevo Casas Grandes",
    "Camargo",
    "Otra ciudad..."
  ],
  
  "Ciudad de México": [
    "Ciudad de México",
    "Otra ciudad..."
  ],
  
  "Coahuila": [
    "Saltillo",
    "Torreón",
    "Monclova",
    "Piedras Negras",
    "Acuña",
    "Ramos Arizpe",
    "Frontera",
    "Otra ciudad..."
  ],
  
  "Colima": [
    "Colima",
    "Manzanillo",
    "Tecomán",
    "Villa de Álvarez",
    "Armería",
    "Cuauhtémoc",
    "Coquimatlán",
    "Otra ciudad..."
  ],
  
  "Durango": [
    "Durango",
    "Gómez Palacio",
    "Lerdo",
    "Santiago Papasquiaro",
    "Guadalupe Victoria",
    "El Salto",
    "Vicente Guerrero",
    "Otra ciudad..."
  ],
  
  "Guanajuato": [
    "León",
    "Irapuato",
    "Celaya",
    "Salamanca",
    "Guanajuato",
    "San Miguel de Allende",
    "Silao",
    "Otra ciudad..."
  ],
  
  "Guerrero": [
    "Acapulco",
    "Chilpancingo",
    "Iguala",
    "Zihuatanejo",
    "Taxco",
    "Chilapa",
    "Tlapa de Comonfort",
    "Otra ciudad..."
  ],
  
  "Hidalgo": [
    "Pachuca",
    "Tulancingo",
    "Tizayuca",
    "Tula de Allende",
    "Tepeji del Río",
    "Huejutla",
    "Ixmiquilpan",
    "Otra ciudad..."
  ],
  
  "Jalisco": [
    "Guadalajara",
    "Zapopan",
    "Tlaquepaque",
    "Tonalá",
    "Puerto Vallarta",
    "Tlajomulco",
    "Lagos de Moreno",
    "Otra ciudad..."
  ],
  
  "Estado de México": [
    "Ecatepec",
    "Nezahualcóyotl",
    "Naucalpan",
    "Tlalnepantla",
    "Toluca",
    "Cuautitlán Izcalli",
    "Atizapán de Zaragoza",
    "Otra ciudad..."
  ],
  
  "Michoacán": [
    "Morelia",
    "Uruapan",
    "Zamora",
    "Lázaro Cárdenas",
    "Pátzcuaro",
    "Apatzingán",
    "Zitácuaro",
    "Otra ciudad..."
  ],
  
  "Morelos": [
    "Cuernavaca",
    "Jiutepec",
    "Cuautla",
    "Temixco",
    "Yautepec",
    "Emiliano Zapata",
    "Jojutla",
    "Otra ciudad..."
  ],
  
  "Nayarit": [
    "Tepic",
    "Bahía de Banderas",
    "Xalisco",
    "Santiago Ixcuintla",
    "Tuxpan",
    "Compostela",
    "Ixtlán del Río",
    "Otra ciudad..."
  ],
  
  "Nuevo León": [
    "Monterrey",
    "Guadalupe",
    "San Nicolás de los Garza",
    "San Pedro Garza García",
    "Apodaca",
    "Santa Catarina",
    "Escobedo",
    "Otra ciudad..."
  ],
  
  "Oaxaca": [
    "Oaxaca de Juárez",
    "Salina Cruz",
    "Juchitán",
    "Tuxtepec",
    "Huajuapan de León",
    "Puerto Escondido",
    "Tehuantepec",
    "Otra ciudad..."
  ],
  
  "Puebla": [
    "Puebla",
    "Tehuacán",
    "San Martín Texmelucan",
    "Atlixco",
    "Cholula",
    "San Pedro Cholula",
    "Teziutlán",
    "Otra ciudad..."
  ],
  
  "Querétaro": [
    "Querétaro",
    "San Juan del Río",
    "Corregidora",
    "El Marqués",
    "Cadereyta de Montes",
    "Tequisquiapan",
    "Jalpan de Serra",
    "Otra ciudad..."
  ],
  
  "Quintana Roo": [
    "Cancún",
    "Playa del Carmen",
    "Chetumal",
    "Cozumel",
    "Tulum",
    "Solidaridad",
    "Isla Mujeres",
    "Otra ciudad..."
  ],
  
  "San Luis Potosí": [
    "San Luis Potosí",
    "Soledad de Graciano Sánchez",
    "Ciudad Valles",
    "Matehuala",
    "Rioverde",
    "Ciudad Fernández",
    "Tamazunchale",
    "Otra ciudad..."
  ],
  
  "Sinaloa": [
    "Culiacán",
    "Mazatlán",
    "Los Mochis",
    "Guasave",
    "Guamúchil",
    "Navolato",
    "El Fuerte",
    "Otra ciudad..."
  ],
  
  "Sonora": [
    "Hermosillo",
    "Cajeme",
    "Nogales",
    "San Luis Río Colorado",
    "Navojoa",
    "Guaymas",
    "Puerto Peñasco",
    "Otra ciudad..."
  ],
  
  "Tabasco": [
    "Villahermosa",
    "Cárdenas",
    "Comalcalco",
    "Huimanguillo",
    "Macuspana",
    "Paraíso",
    "Frontera",
    "Otra ciudad..."
  ],
  
  "Tamaulipas": [
    "Reynosa",
    "Matamoros",
    "Nuevo Laredo",
    "Tampico",
    "Ciudad Victoria",
    "Ciudad Madero",
    "Altamira",
    "Otra ciudad..."
  ],
  
  "Tlaxcala": [
    "Tlaxcala",
    "Apizaco",
    "Huamantla",
    "San Pablo del Monte",
    "Chiautempan",
    "Zacatelco",
    "Calpulalpan",
    "Otra ciudad..."
  ],
  
  "Veracruz": [
    "Veracruz",
    "Xalapa",
    "Coatzacoalcos",
    "Poza Rica",
    "Córdoba",
    "Orizaba",
    "Tuxpan",
    "Otra ciudad..."
  ],
  
  "Yucatán": [
    "Mérida",
    "Kanasín",
    "Valladolid",
    "Tizimín",
    "Progreso",
    "Ticul",
    "Motul",
    "Otra ciudad..."
  ],
  
  "Zacatecas": [
    "Zacatecas",
    "Fresnillo",
    "Guadalupe",
    "Jerez",
    "Río Grande",
    "Sombrerete",
    "Loreto",
    "Otra ciudad..."
  ]
};

/**
 * Lista de estados de México en orden alfabético
 */
export const ESTADOS_MEXICO = Object.keys(CIUDADES_POR_ESTADO).sort();

/**
 * Obtiene las ciudades de un estado específico
 * @param {string} estado - Nombre del estado
 * @returns {Array<string>} - Lista de ciudades
 */
export function getCiudadesPorEstado(estado) {
  return CIUDADES_POR_ESTADO[estado] || [];
}

/**
 * Verifica si una selección es "Otra ciudad"
 * @param {string} ciudad - Nombre de la ciudad seleccionada
 * @returns {boolean} - true si es "Otra ciudad..."
 */
export function esOtraCiudad(ciudad) {
  return ciudad === "Otra ciudad...";
}